import { Form, Modal, Select, notification } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import {
  getInstructors,
  selectAssignableInstructors,
} from "store/slices/instructorsSlice";
import {
  assignInstructorToTraining,
  getTrainingById,
} from "store/slices/trainingsSlice";

const AssignInstructorToTrainingModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form?.useForm();

  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const instructors = useSelector(selectAssignableInstructors);
  const { training, loading } = useSelector((state) => state?.trainings);

  const open = isModalOpen && modalType === "assign_training_instructor";
  const trainingId = modalProps?.trainingId;

  useEffect(() => {
    if (!open) return;
    if (!training || training?._id !== trainingId) {
      dispatch(getTrainingById(trainingId));
    }
    dispatch(getInstructors());
  }, [dispatch, open, trainingId, training]);

  useEffect(() => {
    if (!open || !training) return;
    form?.setFieldsValue({
      instructorId: training?.instructors?.find(
        (instructor) => instructor?.isApproved === "approved"
      )?.instructorId?._id,
    });
  }, [form, open, training]);

  const handleClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  const handleSubmit = async ({ instructorId }) => {
    if (!trainingId || !instructorId) return;
    try {
      await dispatch(
        assignInstructorToTraining({
          trainingId,
          instructorId,
        })
      )?.unwrap();

      notification?.success({
        message: t("trainings.instructor.success", "Instructor assigned"),
      });

      handleClose();
    } catch (error) {
      notification?.error({
        message: t("trainings.instructor.error", "Assignment failed"),
        description: error?.message || t("common.error.generic"),
      });
    }
  };

  return (
    <Modal
      title={t("trainings.instructor.title", "Assign instructor")}
      open={open}
      onCancel={handleClose}
      onOk={() => form?.submit()}
      confirmLoading={loading}
      destroyOnClose
      centered
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="instructorId"
          label={t("instructors.crud.form.label.name")}
          rules={[
            {
              required: true,
              message: t("trainings.instructor.selectRequired", "Select an instructor"),
            },
          ]}
        >
          <Select
            placeholder={t("trainings.instructor.select", "Select an instructor")}
            loading={loading}
            showSearch
            optionFilterProp="children"
          >
            {instructors?.map((instructor) => (
              <Select.Option key={instructor?._id} value={instructor?._id}>
                {instructor?.fullName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AssignInstructorToTrainingModal;
